import script from "./CargoFormView.vue?vue&type=script&setup=true&lang=js"
export * from "./CargoFormView.vue?vue&type=script&setup=true&lang=js"

import "./CargoFormView.vue?vue&type=style&index=0&id=1e5898de&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e5898de"]])

export default __exports__